<template>
  <div class="login">
    <mymenu />
    <div class="login-con">
      <img
        src="../../assets/images/loginbg.jpg"
        width="100%"
        height="100%"
        alt=""
      />
      <div class="register-form">
        <div class="login-inner">
          <h3 class="login-inner-text">用户登录</h3>
          <div class="input">
            <el-input
              placeholder="请输入身份证号/手机号"
              v-model="model.account"
              clearable
            >
            </el-input>
          </div>
          <div class="input">
            <el-input
              clearable
              show-password
              placeholder="请输入密码"
              v-model="model.password"
            >
            </el-input>
          </div>
          <div class="input clearfix">
            <div class="fl">
              <el-input
                placeholder="请输入验证码"
                v-model="model.captcha"
                clearable
                @keyup.enter.native="userLogin"
              >
              </el-input>
            </div>
            <div class="fr">
              <img @click="getCapt()" class="codeImg" :src="url" alt="" />
            </div>
          </div>

          <div class="login-forget-pwd clearfix">
            <router-link to="/forgetPassword" class="fr" style="color: black"
              >忘记密码</router-link
            >
            <i class="span fr" style="color: black">|</i>
            <router-link to="/register" class="fr" style="color: black"
              >注册账户</router-link
            >
          </div>

          <div class="login_center">
            <el-button class="login-btn" @click="userLogin">登录</el-button>
          </div>
        </div>
      </div>
      <applyBottom></applyBottom>
    </div>
  </div>
</template>
<script>
import { getCaptId, getCapt, reqUserLogin, reqUserCertInfo } from "@/api";
import { erroralert, successalert } from "@/utils/alert";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { startIdleTimer } from "@/utils/idleTimeout";

export default {
  data() {
    return {
      url: "",
      model: {
        account: "13870861023",
        password: "Cyj20080827",
        captcha_id: "",
        captcha: "",
      },
    };
  },
  mounted() {
    this.getCapt();
  },
  methods: {
    ...mapActions(useMainStore, [
      "updateToken",
      "updateUserInfo",
      "updateUserCertInfo"
    ]),
    getCapt() {
      getCaptId().then((res) => {
        if (res.data.code == 1) {
          this.model.captcha_id = res.data.data.captcha_id;

          getCapt(this.model.captcha_id).then((res2) => {
            this.url = res2.data.data.img;
          });
        }
      });
    },

    //用户登录
    userLogin() {
      let that = this;

      //用户登录
      reqUserLogin(that.model).then((res) => {
        if (res.data.code === 1) {
          successalert(res.data.msg);
          // 将登录 token 保存到 cookie 中

          this.$cookies.set("token", res.data.data.userinfo.token);

          //存储用户token
          that.updateToken(res.data.data.userinfo.token);
          that.updateUserInfo(res.data.data.userinfo);

          // Start idle timer after successful login (15 min auto-logout)
          startIdleTimer(() => {
            const store = useMainStore();
            store.logout();
            that.$message.warning("由于长时间未操作，系统已自动退出登录，请重新登录");
            that.$router.push("/login");
          }, 15 * 60 * 1000);

          //获取用户信息

          //获取用户信息
          reqUserCertInfo().then((res) => {
            if (res.data.code === 1) {
              //存储用户信息

              if (res.data.data) {
                that.updateUserCertInfo(res.data.data);
                that.$router.push("/");
              } else {
                that.$router.push("/home");
              }
            } else {
            }
          });
        } else {
          erroralert(res.data.msg);
          this.getCapt();
        }
      });
    },
  },
};
</script>
<style scoped></style>
